import { Component } from '@angular/core';

@Component({
    templateUrl: './bidtimeline-help.component.html',
    standalone: false
})
export class BidTimelineHelpComponent { }
